module.exports = __webpack_public_path__ + "static/media/jumbotron_bg.f8789bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/adkonunit/jumbotron_bg.jpg
// module id = 957
// module chunks = 124